import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.1291 19.1291C17.4326 20.8257 15.0889 21.875 12.5 21.875C7.32234 21.875 3.125 17.6777 3.125 12.5C3.125 7.32234 7.32234 3.125 12.5 3.125C15.0889 3.125 17.4326 4.17433 19.1291 5.87089C19.9927 6.73443 21.875 8.85417 21.875 8.85417",
      stroke: "#F4F4F4",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.875 4.1665V8.854H17.1875",
      stroke: "#F4F4F4",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }